import { ParsedBwicProcess } from "../types/models/ParsedBwicProcess";
import { BwicProcessType } from "../types/models/Process";

export const getProcessSpecificSettings = (parsedProcess?: ParsedBwicProcess) => {
    switch (parsedProcess?.processType) {
        case BwicProcessType.JumpBall: return parsedProcess.jumpBall;
        case BwicProcessType.TopX: return parsedProcess.topX;
        case BwicProcessType.BestFootForward: return parsedProcess.bff;
        case BwicProcessType.Unknown: return parsedProcess.unknown;
        default: return {};
    }
}
